import React from 'react';
import AuthHeader from '../../components/AuthHeader';
import { WhiteLogo1 } from '@/assets/images';

// Styles
import './OnBoarding.css';
import theme from '../../assets/theme';

interface OnboardingProps {
  children?: React.ReactNode;
}

/**
 * Onboarding component that provides a layout wrapper for onboarding pages
 *
 * @param children - React nodes to be rendered within the onboarding container
 */
const Onboarding: React.FC<OnboardingProps> = ({ children }) => {
  return (
    <div className='onboarding-container zl-pass-main'>
      <AuthHeader
        bgColor={theme.primary}
        color='#fff'
        logo={WhiteLogo1}
        isSharePage={false}
      />

      <div className='onboarding-middle-container'>{children}</div>
    </div>
  );
};

export default Onboarding;
